import * as React from "react";
import PropTypes from "prop-types";
import {
  Button, FormField, Badge, Form, Header
} from "AWS-UI-Components-React";
import axios from 'axios';
import getMidwayToken from "../utils/getMidwayToken";
import jwtDecode from "jwt-decode";


export class UploadFile extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
            file:null,
            jwtToken: null,
            presignedUrl: null
        }
        this.onFormSubmit = this.onFormSubmit.bind(this)
        this.postFileToS3 = this.postFileToS3.bind(this)
        this.handleFileChange = this.handleFileChange.bind(this)
    }
    async postFileToS3(file){
        let formData = new FormData();
        //console.log(this.state.jwtToken)
        //console.log(jwtDecode(this.state.jwtToken))
        const headers_get = {
            'Authorization': this.state.jwtToken
        }
        const headers = { 'Content-Type': 'application/json',
            'Accept': 'application/json',
            mode: 'cors',
            credentials: 'exclude'
        }
        let geturl = "https://api-us-east-1.test.foaa-automation.finance.amazon.dev/validationapi/validationfilepresigned?filename="+file.name
        let uploadUrl = await fetch(geturl, {'headers': headers_get})
        let presignedUrl = await uploadUrl.json()
        console.log(presignedUrl)
        for(var k in presignedUrl.fields){
            formData.append(k, presignedUrl.fields[k])
        }
        formData.append("file", file)
        //axios.post(presignedUrl.url, formData)
        const xhr = new XMLHttpRequest();
        xhr.open("POST", presignedUrl.url, true);
        xhr.send(formData);
        xhr.onload = function() {
            console.log('something happened')
            console.log(this.responseText);
            };
        console.log("Attempted to upload a file")
    }
    async handleFileChange(event){
        this.setState({file: event.target.files[0]})
        await getMidwayToken()
          .then(response => {
              this.setState({
                  jwtToken: response
              })
          })
            .catch(error => {
                console.log(error)
            })
    }

    fileUploadButton() {
        return (
            <FormField
                id="mjeFileUpload"
                label="Upload MJE File"
                description="Upload your MJE file here , only xlsx files for now"
            >
        <input
          //ref={this.hiddenFileInput}
          id="chooseMJEFile"
          type="file"
          multiple={false}
          //accept="text/csv/xlsx"
          onChange={this.handleFileChange}
        />
        <Button
          icon="upload"
          id="chooseMJEButton"
          formAction="submit"
        >
          Validate MJE
        </Button>
      </FormField>
        );
    }

    onFormSubmit(e){
        e.preventDefault()
        console.log(`Selected file - ${this.state.file.name}`)
        //console.log(this.state.file)

        this.postFileToS3(this.state.file)
    }

    render(){
    return(
        <form onSubmit={this.onFormSubmit}>
            <Form header={<h1>MJE Validation Service</h1>}
            >
                    {this.fileUploadButton()}

            </Form>
        </form>
        )
    }
};

export default UploadFile;





// WEBPACK FOOTER //
// ./src/components/uploadFile.js